import PropTypes from 'prop-types';
import toastr from 'toastr';
import { showModal } from '../../../../../Actions/PopUp';
import { IconCopyshare, IconGmail, IconTwitter, IconWhatsapp, SelectedClose } from '../../../../../assets/images';
import { useChannelInfo } from '../../../../../slice';
import { Store } from '../../../../../store';
import './ChannelSharePopup.scss';
import logger from '../../../../../Helpers/logger';

const SHARE_TITLE = 'Check out this channel';

const ChannelSharePopup = ({ channelId = {}, onClose }) => {
    const channelInfo = useChannelInfo(channelId);
    const shareUrl = channelInfo?.accessUri;

    const shareText = `Join ${channelInfo?.name || 'our channel'}: ${shareUrl}`;

    const handleClosePopup = () => {
        if (onClose) {
            onClose();
        } else {
            Store.dispatch(
                showModal({
                    open: false,
                    modelType: 'joinRequest',
                }),
            );
        }
    };

    const handleCopy = () => {
        navigator.clipboard
            .writeText(shareUrl)
            .then(() => {
                handleClosePopup();
                toastr.success('Link copied successfully!');
            })
            .catch(err => {
                logger.error('Failed to copy text: ', err);
            });
    };

    const handleWhatsApp = () => {
        const encodedMessage = encodeURIComponent(shareText);
        const url = `https://wa.me/?text=${encodedMessage}`;
        window.open(url, '_blank');
        handleClosePopup();
    };

    const handleGmail = () => {
        const encodedSubject = encodeURIComponent(SHARE_TITLE);
        const encodedBody = encodeURIComponent(shareText);
        const url = `https://mail.google.com/mail/?view=cm&fs=1&su=${encodedSubject}&body=${encodedBody}`;
        window.open(url, '_blank');
        handleClosePopup();
    };

    const handleX = () => {
        const encodedMessage = encodeURIComponent(shareText);
        const url = `https://twitter.com/messages/compose?text=${encodedMessage}`;
        // If you have specific usernames to send to, you can include them
        // const url = `https://twitter.com/messages/compose?recipient_id=USER_ID&text=${encodedMessage}`;
        window.open(url, '_blank');
    };

    return (
        <div className="popup-wrapper share-popup">
            <div className="share-container">
                <div className="share-popup-wrapper">
                    <div className="share-header">
                        <h3 className="share-title">Share</h3>
                        <button
                            className="close-button"
                            onClick={handleClosePopup}
                            onKeyDown={e => e.key === 'Enter' && handleClosePopup()}
                            aria-label="Close popup"
                        >
                            <SelectedClose />
                        </button>
                    </div>

                    <div className="share-options">
                        <button className="share-option" onClick={handleCopy}>
                            <div className="share-icon copy-icon">
                                <IconCopyshare />
                            </div>
                            <span className="share-label">Copy</span>
                        </button>

                        <button className="share-option" onClick={() => handleWhatsApp()}>
                            <div className="share-icon whatsapp">
                                <IconWhatsapp />
                            </div>
                            <span className="share-label">WhatsApp</span>
                        </button>

                        <button className="share-option" onClick={() => handleGmail()}>
                            <div className="share-icon gmail">
                                <IconGmail />
                            </div>
                            <span className="share-label">Gmail</span>
                        </button>

                        <button className="share-option" onClick={() => handleX()}>
                            <div className="share-icon twitter">
                                <IconTwitter />
                            </div>
                            <span className="share-label">X</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

ChannelSharePopup.propTypes = {
    channelId: PropTypes.string,
    onClose: PropTypes.func,
};

export default ChannelSharePopup;
